import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from './br-angular-material.module';
import { PopoverModule } from 'ngx-bootstrap';
import { CollapseModule } from 'ngx-bootstrap';
import { AlertModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap';


import { BrToggleComponent } from './br-toggle/br-toggle.component';
// import { LabContactComponent } from './forms/lab-contact/lab-contact.component';
// import { LocationComponent } from './forms/location/location.component';
// import { LocationNameComponent } from './forms/location-name/location-name.component';
import { HistoryComponent } from './history/history.component';
import { RowControlsComponent } from './row-controls/row-controls.component';
import { CardHdrComponent } from './card-hdr/card-hdr.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { InputComponent } from './forms/input/input.component';
import { TblScrollXDirective } from './tbl-scroll-x.directive';
import { DataCardsModule } from './data-cards/data-cards.module';
import { MvpTblComponent } from './mvp-tbl/mvp-tbl.component';
import { OnboardingHdrComponent } from './onboarding-hdr/onboarding-hdr.component';
import { FieldCtnComponent } from './field-ctn/field-ctn.component';
import { BrSliderComponent } from './br-slider/br-slider.component';
import { BrInstrumentComponent } from './br-instrument/br-instrument.component';
import { BrSelectComponent } from './forms/br-select/br-select.component';
import { ContentSliderComponent } from './br-content-slider/br-content-slider.component';
import { ExpansionPanelComponent } from './br-expansion-panel/br-expansion-panel.component';
import { HighLowValueDirective } from './high-low-value/high-low-value.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule, ReactiveFormsModule,
        AngularMaterialModule,
        PopoverModule.forRoot(),
        CollapseModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        DataCardsModule
    ],
    exports: [
        FormsModule, ReactiveFormsModule,
        BrToggleComponent,
        // LabContactComponent,
        // LocationComponent,
        // LocationNameComponent,
        HistoryComponent,
        RowControlsComponent,
        CardHdrComponent,
        InputComponent,
        SafeHtmlPipe,
        TblScrollXDirective,
        DataCardsModule,
        MvpTblComponent,
        OnboardingHdrComponent,
        FieldCtnComponent,
        BrSliderComponent,
        BrInstrumentComponent,
        BrSelectComponent,
        ContentSliderComponent,
        ExpansionPanelComponent,
        HighLowValueDirective,

        AngularMaterialModule,
        PopoverModule,
        CollapseModule,
        AlertModule,
        ModalModule
     ],
    declarations: [BrToggleComponent,
        HistoryComponent, RowControlsComponent, CardHdrComponent, InputComponent, SafeHtmlPipe, TblScrollXDirective, MvpTblComponent,
        OnboardingHdrComponent, FieldCtnComponent, BrSliderComponent, BrInstrumentComponent, BrSelectComponent, ContentSliderComponent,
        ExpansionPanelComponent, HighLowValueDirective]
    //   LabContactComponent, LocationComponent, LocationNameComponent,
})
export class WidgetsModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/widgets.module.ts